"use client";

import { Plus } from "geist-icons";
import Link from "next/link";
import React from "react";
import { Button } from "../../ui/button";
import { Vortex } from "./new-vortex";
import { TextGenerateEffect } from "./text-generate-effect";

export default function HeroHome() {

  return (
    <section className="relative w-full bg-[#FAFAFA] dark:bg-black min-w-[320px] flex items-center justify-center px-4 sm:px-6 md:px-8 lg:px-10">
      {/* Wrapper to control the width of the grid */}
      <div className="relative z-[20] w-full max-w-[1100px] mt-12 sm:mt-16 md:mt-20 lg:mt-24">
        {/* Grid container with fixed height classes instead of dynamic calculation */}
        <div className="relative z-[50] w-full h-[500px] sm:h-[550px] md:h-[600px] lg:h-[650px] border-l-2 border-r-2 border-t-2 border-[#EAEAEA] dark:border-[#1E1E1E] flex flex-col mx-auto">
          {/* Top left plus sign */}
          <div className="absolute z-[30] md:-top-[11px] -top-[10px] md:-left-[11px] -left-[11px] flex items-center justify-center">
            <Plus className="text-[#A8A8A8] dark:text-[#878787] scale-100 md:scale-130" />
          </div>
          {/* Vortex stays inside the grid */}
          <div className="absolute z-0 flex items-center flex-col justify-center w-full h-full overflow-hidden">
            <Vortex
              baseHue={42}
              className="flex items-center flex-col justify-center w-full h-full"
            ></Vortex>
          </div>
          {/* Content container */}
          <div className="relative flex items-center flex-col justify-center w-full h-full">
            <div className="relative z-20 w-full sm:max-w-[80vw] md:max-w-3xl lg:max-w-3xl xl:max-w-4xl flex flex-col items-center px-2">
              <h2 className="uppercase tracking-widest text-sm text-center text-[#666666] dark:text-[#A0A0A0] mb-4">
                Hi, I am Alex
              </h2>

              <TextGenerateEffect
                className="relative text-center text-[30px] sm:text-[45px] md:text-5xl lg:text-6xl xl:text-7xl font-bold max-w-full mb-6 leading-tight"
                words="AI-Driven * Full Stack Developer"
              />

              <h6 className="text-center text-md md:text-lg lg:text-xl leading-normal pb-7 text-[#666666] dark:text-[#A0A0A0] max-w-[100%] break-words">
                I develop modern and tailored websites and web apps, scalable
                and ultra-performant guaranteeing security, speed and innovation{" "}
                <span className="whitespace-nowrap">
                  with Next.js, Vercel and AI
                </span>
              </h6>

              <div className="relative flex flex-row items-center gap-4 w-full justify-center">
                <Link href="/contact" className="flex items-center">
                  <Button
                    type="button"
                    className="w-full sm:w-36 h-12 text-md dark:text-black text-white dark:bg-white bg-[#0A0A0A] dark:hover:bg-[#A0A0A0] hover:bg-[#666666] rounded-full cursor-pointer"
                  >
                    Contact Me
                  </Button>
                </Link>
                <Link href="/service" className="flex items-center">
                  <Button
                    variant="outline"
                    type="button"
                    className="w-full sm:w-36 h-12 text-md border border-[#EAEAEA] dark:border-[#282828] dark:bg-[#0A0A0A] hover:bg-[#F4F4F5] dark:hover:bg-[#1E1E1E] rounded-full cursor-pointer"
                  >
                    My Services
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
